import { withResetStateConst } from "./withResetState.const";

type WithResetStateProps = {
	resetLocalStateType?: string;
	initialState: { [key: string]: any };
};

export const withResetState = ({
	resetLocalStateType: resetLocalType,
	initialState,
}: WithResetStateProps) => baseReducer => (state, action) => {
	const newState =
		action.type === resetLocalType ||
		action.type === withResetStateConst.RESET_GLOBAL_STATE
			? { ...initialState }
			: state;

	return baseReducer(newState, action);
};
